import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {DcPageDto, DcTreeNode} from "../model/dto/entity/dc-page.dto";
import {MvsCrudService} from "../../../core/shared/service/crud/mvs-crud.service";

@Injectable({
    providedIn: 'root'
})
export class DcPageService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/dc/pages')
    }

    getPageHierarchy(id: number): Observable<DcTreeNode<DcPageDto>> {
        return this.http.get<DcTreeNode<DcPageDto>>(`${this.apiUrl}/${id}/hierarchy`);
    }

    createPageContent(
        pageTypeId: number,
        parentId?: number,
        title?: string,
        orderPriority?: number,
        objectTypeId?: number,
        objectId?: number
    ): Observable<DcPageDto> {

        let params = new HttpParams();

            if (parentId !== undefined) {
                params = params.set('parentId', parentId);
            }
            if (title !== undefined) {
                params = params.set('title', title);
            }
            if (orderPriority !== undefined) {
                params = params.set('orderPriority', orderPriority);
            }
            if (objectTypeId !== undefined) {
                params = params.set('objectTypeId', objectTypeId);
            }
            if (objectId !== undefined) {
                params = params.set('objectId', objectId);
            }

        const endPoint = `${this.apiUrl}/create/${pageTypeId}`;

        return this.http.post<DcPageDto>(
            endPoint,
            null,
            {params}
        );
    }

    getPageAncestors(pageId: number): Observable<DcTreeNode<DcPageDto>> {
        const endPoint = `${this.apiUrl}/${pageId}/getAncestors`;

        return this.http.get<DcTreeNode<DcPageDto>>(endPoint);

    }

}
